/** Active preset colors from the Workshop Figma palette. */
export const NEUTRAL_PRESET_COLOR = '#172B4D';

export const PRESET_COLORS = [
  '#0065FF',
  '#E32C1E',
  NEUTRAL_PRESET_COLOR,
  '#24A148',
  '#00B1D0',
  '#6554C0',
  '#EE5396',
  '#FFD600',
  '#FF9800',
] as const;

export const DEFAULT_PRESET_COLOR = 'transparent';
